import Vue from 'vue'
import CodeServices from '../../services/CodeServices'
import CodeGroupId from '../../code/CodeGroupId'

const types = {
  GET_COMMON_CODE_GROUP_LIST: '@CODE/GET_COMMON_CODE_GROUP_LIST',
  GET_COMMON_CODE_GROUP_DETAIL: '@CODE/GET_COMMON_CODE_GROUP_DETAIL'
}

export {
  types as codeTypes
}

export default {
  namespaced: true,
  state: {
    codeCommonGroup: [],
    // 초기값은 반드시 있어야 함 //
    COM001: [],
    COM002: [],
    COM003: [],
    COM004: [],
    COM005: [],
    COM006: [],
    COM007: [],
    COM008: [],
    COM009: [],
    COM010: [],
    COM011: [],
    COM012: [],
    COM013: [],
    COM014: [],
    COM015: [],
    COM016: [],
    COM017: [],
    COM018: [],
    COM019: [],
    COM999: [],
  },

  getters: {
    commonGroupCode: state => {
      return state.commonGroupCode
    },
    userGroupList: state => state[CodeGroupId.USERGROUP].filter(item => item.useYn === 'Y') || [],
    snsList: state => state[CodeGroupId.SNS].filter(item => item.useYn === 'Y') || [],
    middleGroupList: state => state[CodeGroupId.MIDDLE_MANAGER].filter(item => item.useYn === 'Y') || [],
  },

  mutations: {
    [types.GET_COMMON_CODE_GROUP_LIST] (state, { codeCommonGroup }) {
      state.codeCommonGroup = codeCommonGroup
    },
    [types.GET_COMMON_CODE_GROUP_DETAIL] (state, { codeGroupId, codeGroupDetail }) {
      Vue.set(state, codeGroupId, codeGroupDetail)
    }
  },

  actions: {
    async getCommonCodeGroups ({ commit }) {
      const response = await CodeServices.getCommonCodeGroup()

      commit(types.GET_COMMON_CODE_GROUP_LIST, {
        codeCommonGroup: response.data.resultData
      })
    },
    // codeGroupId가 변할수 있기 때문에
    // 반드시 /src/code/CodeGroupId를 참조해서 사용해야합니다 //
    async getCommonCodeGroupDetail ({ commit} , { codeGroupId }) {
      const response = await CodeServices.getCommonCodeGroupDetailWithCodeGroupId(codeGroupId)

      commit(types.GET_COMMON_CODE_GROUP_DETAIL, {
        codeGroupId,
        codeGroupDetail: response.data.resultData
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/code.js